import React from 'react'
import { Box, Text, Button, Accordion, Group, ActionIcon, Grid } from '@mantine/core'
import dayjs from 'dayjs'
import classes from './DetailSlug.module.css'
import { formatPrice } from '../../../../plugins/formatPrice'
import { useNavigate, useParams } from 'react-router-dom'
import { IconMap2 } from '@tabler/icons-react'
import { useDispatch } from 'react-redux'
import { update } from '../../../../store/cartData'
import { useLocalStorage } from '@mantine/hooks'
import { useSelector } from 'react-redux'

const defaultRoute = {
  key: 'route',
  defaultValue: ''
}

const MappingTypeEvent = ({ address, onlineLink, mapLink, dataEvent }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const [, setRoute] = useLocalStorage(defaultRoute)
  const { isLogin } = useSelector(state => state.auth)

  const handleCheckout = (scheduleId, schedulePrice) => {
    const data = {
      transactionMethodId: null,
      eventScheduleIds: [ scheduleId ],
      eventSlug: params.slug,
      totalPrice: schedulePrice
    }
    dispatch(update({ 'cart': data }))
    if (!isLogin) {
      navigate("/login")
      setRoute('/checkout')
    } else {
      navigate("/checkout")
    }
  }

  const mappingButton = (valueSchedule) => {
    if (valueSchedule.status === 'registration_open') {
      return (<Button radius="md" size='xs' onClick={() => handleCheckout(valueSchedule.id, valueSchedule.price)}>Daftar Sekarang</Button>)
    } else if (valueSchedule.status === 'coming_soon') {
      return (<Button radius="md" size='xs' color="green.4">Upcoming Event</Button>)
    } else {
      return (<Button radius="md" size='xs' color="red">Pendaftaran Ditutup</Button>)
    }
  }

  if (address !== null) {
    const handleMapLink = (link) => {
      window.open(`${link}`, '_blank')
    }
    return (
      <Box>
        <Grid>
          <Grid.Col span={{ base: 12, lg: 8 }}>
            <Box align="left" mb={10}>
              <Text fz={16} fw="600" mb={6}>Tipe: Offline</Text>
              <Text fz={14} fw="500" mb={8}>Tipe pembelajaran akan dilakukan secara offline. Untuk lokasi pembelajaran bisa di cek di alamat berikut ini:</Text>
              <Text fz={14} fw="500" mb={4}>Alamat: {address}</Text>
              <Group spacing="xs">
                <ActionIcon color="red">
                  <IconMap2 size="1.5rem" />
                </ActionIcon>
                <Text fz="sm">Klik <Text component='span' fw="500" color='red' style={{ cursor: 'pointer' }} onClick={() => handleMapLink(mapLink)}>disini</Text> untuk menunjukkan peta lokasi</Text>
              </Group>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, lg: 4 }}>
            <Box align="right">
              {mappingButton(dataEvent)}
            </Box>
          </Grid.Col>
        </Grid>
      </Box>
    )
  }
  if (onlineLink !== null) {
    return (
      <Box>
        <Grid>
          <Grid.Col span={{ base: 12, lg: 8}}>
            <Box align="left">
              <Text fz={16} fw='600' mb={6}>Tipe: Online</Text>
              <Text fz={14}>Tipe pembelajaran akan dilakukan secara online melalui platform online seperti Google Meet, Zoom, dll</Text>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, lg: 4}}>
            <Box align="right">
              {mappingButton(dataEvent)}
            </Box>
          </Grid.Col>
        </Grid>
      </Box>
    )
  }
}

const ScheduleSection = ({ schedules }) => {
  const isExpiredEvent = (endtimeEvent) => {
    const now = dayjs().unix()
    const expired = dayjs(endtimeEvent).subtract(7, 'hours').unix()
    return now > expired
  }

  const emptySchedules = () => {
    return (
      <Box p={16}>
        <Text align="center" fz="md" fw="bold">Event Ini Belum Memiliki Schedule</Text>
      </Box>
    )
  }

  const listSchedules = () => {
    return (
      <Accordion chevronPosition="left" variant="separated" mx="auto" styles={{ content: { paddingTop: '20px' } }}>
        <Grid align="flex-start">
          {mappingActiveSchedules(schedules)}
          {mappingInactiveSchedules(schedules)}
        </Grid>
      </Accordion>
    )
  }

  const mappingActiveSchedules = (dataSchedules) => {
    if (dataSchedules) {
      const sortActiveSchedule = dataSchedules.sort((a,b) => isExpiredEvent(a.eventEnd) - isExpiredEvent(b.eventEnd))

      // eslint-disable-next-line
      const remapDataSchedules = sortActiveSchedule.map((val, index) => {
        const formatTime = (time) => {
          return time.slice(0, -3)
        }
        if (!isExpiredEvent(val.eventEnd)) {
          return (
            <Grid.Col span={{ base: 12, lg: 6 }}>
              <Accordion.Item value={val.id} key={val.name} style={{ border: '0.125rem solid #dee2e6', borderRadius: '10px', padding: '10px' }}>
                <Accordion.Control style={{ alignItems: 'baseline' }}>
                  <Grid>
                    <Grid.Col span={{ base:12, lg: 8 }}>
                      <Box align="left">
                        <Text fz={14} fw="bold" mb={8}>{val.name}</Text>
                        <Box>
                          <Box mb={6}>
                            <Text fz={13} className={classes.dateSection}>Waktu Pelaksanaan:</Text>
                            <Text fz={13} fw='600' className={classes.dateSection}>{formatTime(val.timeStart)} - {formatTime(val.timeEnd)}</Text>
                          </Box>
                          <Box mb={6}>
                            <Text fz={13} className={classes.dateSection}>Registrasi Dimulai:</Text>
                            <Text fz={13} fw='600' className={classes.dateSection}>{dayjs(val.regisStart).format('DD MMM YYYY')} - {dayjs(val.regisEnd).format('DD MMM YYYY')}</Text>
                          </Box>
                          <Box mb={6}>
                            <Text fz={13} className={classes.dateSection}>Training Dimulai:</Text>
                            <Text fz={13} fw='600' className={classes.dateSection}>{dayjs(val.eventStart).format('DD MMM YYYY')} - {dayjs(val.eventEnd).format('DD MMM YYYY')}</Text>
                          </Box>
                        </Box>
                      </Box>
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, lg: 4 }}>
                      <Box align="right">
                        <Text fz="xs" mb={14} c="dimmed" align="right">Quota Peserta : {val.quota}</Text>
                        <Text className={classes.priceSection} fw="bold" c="red">{formatPrice(val.price)}</Text>
                      </Box>
                    </Grid.Col>
                  </Grid>
                </Accordion.Control>
                <Accordion.Panel style={{ borderTop: '1px solid #C1C2C5' }}>
                  <Box>
                    <MappingTypeEvent address={val.address} onlineLink={val.onlineLink} mapLink={val.mapLink} dataEvent={val} />
                  </Box>
                </Accordion.Panel>
              </Accordion.Item>
            </Grid.Col>
          )
        }
      })

      return remapDataSchedules
    }
  }
  const mappingInactiveSchedules = (dataSchedules) => {
    if (dataSchedules) {
      const sortInactiveSchedule = dataSchedules.sort((a,b) => !isExpiredEvent(a.eventEnd) - !isExpiredEvent(b.eventEnd))

      // eslint-disable-next-line
      const remapDataSchedules = sortInactiveSchedule.map((val, index) => {
        const formatTime = (time) => {
          return time.slice(0, -3)
        }
        if (isExpiredEvent(val.eventEnd)) {
          if (index < 2) {
            return (
              <Grid.Col span={{ base: 12, lg: 6 }}>
                <Accordion.Item value={val.id} key={val.name} style={{ border: '0.125rem solid #dee2e6', borderRadius: '10px', padding: '12px' }}>
                  <Accordion.Control disabled style={{ alignItems: 'baseline' }}>
                    <Grid>
                      <Grid.Col span={{ base:12, lg: 8 }}>
                        <Box align="left">
                          <Text fz={14} fw="bold" mb={8}>{val.name}</Text>
                          <Box>
                            <Box mb={6}>
                              <Text fz={13} className={classes.dateSection}>Waktu Pelaksanaan:</Text>
                              <Text fz={13} fw='600' className={classes.dateSection}>{formatTime(val.timeStart)} - {formatTime(val.timeEnd)}</Text>
                            </Box>
                            <Box mb={6}>
                              <Text fz={13} className={classes.dateSection}>Registrasi Dimulai:</Text>
                              <Text fz={13} fw='600' className={classes.dateSection}>{dayjs(val.regisStart).format('DD MMM YYYY')} - {dayjs(val.regisEnd).format('DD MMM YYYY')}</Text>
                            </Box>
                            <Box mb={6}>
                              <Text fz={13} className={classes.dateSection}>Training Dimulai:</Text>
                              <Text fz={13} fw='600' className={classes.dateSection}>{dayjs(val.eventStart).format('DD MMM YYYY')} - {dayjs(val.eventEnd).format('DD MMM YYYY')}</Text>
                            </Box>
                          </Box>
                        </Box>
                      </Grid.Col>
                      <Grid.Col span={{ base: 12, lg: 4 }}>
                        <Box align='right'>
                          <Text fz="xs" mb={18} color="dimmed" align="right">Quota Peserta : {val.quota}</Text>
                          <Button disabled radius="md" size='xs'>Event Berakhir</Button>
                        </Box>
                      </Grid.Col>
                    </Grid>
                  </Accordion.Control>
                </Accordion.Item>
              </Grid.Col>
            )
          }
        }
      })

      return remapDataSchedules
    }
  }

  return (
    <Box mb={35}>
      <Text fz="md" fw="bold">Jadwal & Biaya Pendaftaran</Text>
      <Box mt="md">
        {schedules.length > 0 ? listSchedules() : emptySchedules()}
      </Box>
    </Box>
  )
}

export default ScheduleSection